export default Object.freeze({
  IntercambioDeCentro: 93,
  IntercambioDeEscuela: 45,
  InventarioDeEscuela: 46,
  InventarioDeCentro: 454,
});
